export default class CarPoolsUpload {

    constructor(selector) {
        this.$plugin = $(selector)
        let $plugin = this.$plugin
        if ($plugin.length === 0) {
            return false
        }

        this.$form = this.$plugin.find('form')
        this.dropArea = document.querySelector('[data-tncp-carpoolsupload="drop"]')
        this.selectedFilesWrapper = document.querySelector('[data-tncp-carpoolsupload="selectedFilesWrapper"]')
        this.submitButton = document.querySelector('[data-tncp-carpoolsupload="submitbutton"]')
        this.selectedFiles = document.querySelector('[data-tncp-carpoolsupload="selectedFiles"]')
        this.maxUploadSizeReached = document.querySelector('[data-tncp-carpoolsupload="maxUploadSizeReached"]')
        this.maxUploadSize = 5242880 // 5 megabytes
        this.filesArray = []
        this.init()
    }

    init() {
        let vm = this
        vm.showSelectedFiles()

        // event listener: prevent default behaviour
        ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            this.dropArea.addEventListener(eventName, vm.preventDefaults, false)
        })

        // event listener: drag over dropzone
        ;['dragenter', 'dragover'].forEach(eventName => {
            this.dropArea.addEventListener(eventName, () => {
                vm.highlight()
            }, false)
        })

        // event listener: dragleave & drop over dropzone
        ;['dragleave', 'drop'].forEach(eventName => {
            this.dropArea.addEventListener(eventName, () => {
                vm.unhighlight()
            }, false)
        })

        // event listener: drop files
        this.dropArea.addEventListener('drop', (event) => {
            vm.handleDrop(event)
        }, false)

        // on submit
        vm.$form.submit(function (e) {
            if (vm.filesArray.length > 0) {

                let xhrUrl = $(this).attr('action')
                let completeUploadFinished = false
                vm.disableSubmitButton()
                vm.showLoadingPopup()
                vm.showSelectedFiles()
                let promises = []

                // iterate through files array
                vm.filesArray.forEach((file, index) => {

                    // collect form data to transmit
                    let formData = new FormData();
                    vm.$form.serializeArray().forEach((element, index) => {
                        formData.append(element.name, element.value);
                    });
                    formData.append("tx_tuevnordcustomerportal_api[file]", vm.filesArray[index]);

                    // create promises to fetch result together
                    let promise = new Promise((resolve, reject) => {

                        // xhr
                        window.xhrRequest({
                            url: xhrUrl,
                            method: 'POST',
                            data: formData
                        }).then((response) => {
                            if (response.data.result.uploadStatus === true) {
                                $('[data-tncp-carpoolsupload-selectedfile="' + response.data.result.fileName + '"]').hide()
                            } else {
                                $('[data-tncp-carpoolsupload-selectedfile="' + response.data.result.fileName + '"]').addClass('error')
                            }
                            resolve(response.data.result)
                        }).catch((e) => {
                            reject(e);
                        })
                    })

                    // push promise to promises array
                    promises.push(promise)
                });

                // if all promises are resolved
                Promise.all(promises).then((results) => {
                    completeUploadFinished = true
                    vm.hidePopups()

                    // behaviour if not all uploads succeded / if all uploads succeded
                    if (vm.checkCompleteResponseResult(results) === false) {
                        vm.showConfirmationPopup('error');
                        results.forEach((result, key) => {
                            if (result.reason !== '') {
                                $(document).find('[data-tncp-carpoolsupload="errorMessage"]').html(result.reason);
                            }
                        })

                    } else {
                        vm.flushFilesArray();
                        vm.showConfirmationPopup('success');
                        window.CarPoolsOverview.loadData(1);
                    }
                    vm.enableSubmitButton()
                }).catch((e) => {
                    vm.enableSubmitButton()
                    console.log(e)
                });

            }

            // prevent the defaults on submit
            vm.preventDefaults(e)
        })
    }

    handleDrop(event) {
        let dt = event.dataTransfer;
        let files = dt.files;
        this.handleFiles(files);
    }

    handleFiles(files) {
        let vm = this;
        ([...files]).forEach(file => {
            let extension = file.name.split('.').pop();
            if (extension === 'csv' || extension === 'xlsx') {
                vm.addFile(file)
            }
        });
    }

    addFile(file) {
        // Only allow one file to be added
        this.flushFilesArray();

        if (this.existsInFilesArray(file) === false) {
            this.filesArray.push(file)
        }

        this.showSelectedFiles()
        this.toggleSubmitActivation()
    }

    removeFile(index, reloadSelectedFiles = true) {
        this.filesArray.splice(index, 1);

        if (reloadSelectedFiles) {
            this.showSelectedFiles()
        }
        this.toggleSubmitActivation()

        if (this.filesArray.length === 0) {
            let $selectedFilesWrapper = $(this.selectedFilesWrapper)
            $selectedFilesWrapper.hide();
        }
    }

    removeFileByName(fileName, reloadSelectedFiles = true) {
        let vm = this
        this.filesArray.forEach((result, key) => {
            if (fileName === result.name) {
                vm.removeFile(key, reloadSelectedFiles)
            }
        })
    }

    flushFilesArray() {
        this.filesArray = []
        this.showSelectedFiles()
    }

    toggleSubmitActivation() {
        if (this.hasFiles() && this.checkMaxUploadSizeReached() === false) {
            this.enableSubmitButton()
        } else {
            this.disableSubmitButton()
        }
    }

    hasFiles() {
        return this.filesArray.length > 0;
    }

    getFiles() {
        return this.filesArray();
    }

    checkMaxUploadSizeReached() {
        return this.getFilesize() >= this.maxUploadSize;
    }

    checkCompleteResponseResult(results) {
        let status = true
        results.forEach((result) => {
            if (result.uploadStatus === false && status !== false) {
                status = false
            }
        });
        return status
    }

    getFilesize() {
        let fileSize = 0
        if (this.filesArray.length > 0) {
            this.filesArray.forEach((file) => {
                fileSize = fileSize + file.size
            });
        }
        return fileSize
    }

    showSelectedFiles() {
        let vm = this
        let $selectedFilesWrapper = $(this.selectedFilesWrapper)
        let $selectedFiles = $(this.selectedFiles)
        $selectedFilesWrapper.hide();
        $selectedFiles.html('')
        if (this.filesArray.length > 0) {
            $selectedFilesWrapper.show();
            this.filesArray.forEach((file, index) => {
                let fileSize = vm.formatBytes(file.size, 1)
                $selectedFiles.append(`<div class="c-dragndrop__file-wrap" data-tncp-carpoolsupload-selectedindex="${index}" data-tncp-carpoolsupload-selectedfile="${file.name}"><div class="c-dragndrop__file-name">${file.name} (${fileSize}) <span data-tncp-carpoolsupload-fileexists="${index}" style="display: none; margin-left: 0;"><br><i><b>Datei existiert bereits</b></i></span></div><div class="c-dragndrop__file-delete" onclick="window.CarPoolsUpload.removeFromSelectedFiles('${file.name}')"><span data-icon="ui_close"></span></div></div>`)
            });
        }

        if (vm.checkMaxUploadSizeReached()) {
            vm.showMaxUploadSizeReached()
        } else {
            vm.hideMaxUploadSizeReached()
        }
    }

    removeFromSelectedFiles(fileName) {
        this.removeFileByName(fileName, false)
        $(`[data-tncp-carpoolsupload-selectedfile="${fileName}"]`).hide()
    }

    highlight() {
        this.dropArea.classList.add('is-active')
    }

    unhighlight() {
        this.dropArea.classList.remove('is-active')
    }

    showMaxUploadSizeReached() {
        this.maxUploadSizeReached.style.display = 'block'
    }

    hideMaxUploadSizeReached() {
        this.maxUploadSizeReached.style.display = 'none'
    }

    enableSubmitButton() {
        this.submitButton.disabled = false
    }

    disableSubmitButton() {
        this.submitButton.disabled = true
    }

    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    existsInFilesArray(fileName) {
        let status = false
        if (this.filesArray.length > 0) {
            this.filesArray.forEach((existingFile) => {
                if (fileName.name === existingFile.name && status !== true) {
                    status = true
                }
            });
        }
        return status
    }

    showLoadingPopup() {
        $.magnificPopup.open({
            items: {
                src: '#popup_loadingAssessmentsUpload',
            },
            type: 'inline',
            closeOnBgClick: false,
            enableEscapeKey: false,
            showCloseBtn: false
        });
    }

    showConfirmationPopup(type) {
        if (type === 'success') {
            $.magnificPopup.close();
            this.$form.hide();
            document.querySelector('[data-carpoolsupload="success"]').classList.remove('mfp-hide');
        } else if (type === 'error') {
            $.magnificPopup.open({
                items: {
                    src: '#popup_error',
                },
                type: 'inline',
            });
        }


    }

    hidePopups() {
        $.magnificPopup.close();
    }

    preventDefaults(e) {
        e.preventDefault()
        e.stopPropagation()
    }
}
